import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';
import { RadioButtonStyled } from './RadioButtonStyled';

const RadioButton = (props) => {
  return (
    <>
      <RadioButtonStyled className={props?.appVariant}>
        <Form.Check
          disabled={props?.disable}
          checked={props?.checked}
          className={props?.className}
          name={props?.name}
          type="radio"
          id={props?.id}
          label={props?.label}
          value={props?.value}
          onClick={props?.onClick}
          isInvalid={props?.isInvalid}
        />
      </RadioButtonStyled>
    </>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  disable: PropTypes.bool,
  checked: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  appVariant: PropTypes.string,
  value: PropTypes.string,
  isInvalid: PropTypes.any,
  errorMessage: PropTypes.string,
  outerCustomClass: PropTypes.string,
};

RadioButton.defaultProps = {
  id: '',
  label: '',
  className: '',
  outerCustomClass: '',
};

export default RadioButton;
